"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WelcomeToTheLight() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="87014" id="starkare-tillsammans-tesla-försäkringserbjudanden" className="relative w-full bg-background text-foreground overflow-hidden py-20 lg:py-32">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div ref={textRef} className={`relative flex flex-col items-start transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {}
            <div className="absolute -top-32 -left-32 w-[150%] h-[150%] -z-10 pointer-events-none opacity-[0.05] text-primary">
              <svg viewBox="0 0 200 200" className="w-full h-full" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M10,190 Q60,120 180,20" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" />
                {}
                <path d="M150,45 C130,25 160,10 170,25 C180,40 160,60 150,45 Z" />
                <path d="M110,85 C90,65 120,50 130,65 C140,80 120,100 110,85 Z" />
                <path d="M70,125 C50,105 80,90 90,105 C100,120 80,140 70,125 Z" />
                <path d="M160,35 C175,20 190,40 180,55 C170,70 145,50 160,35 Z" />
                <path d="M120,75 C135,60 150,80 140,95 C130,110 105,90 120,75 Z" />
              </svg>
            </div>

            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-primary leading-[1.1] tracking-tight mb-6">
              Starkare tillsammans
            </h1>
            
            <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-md leading-relaxed">
              Vi förenar Tesla-ägare för att förhandla fram marknadens mest förmånliga försäkringslösningar. Upplev trygghet anpassad för framtidens mobilitet.
            </p>

            <Button asChild variant="default" size="lg" className="rounded-sm bg-primary text-primary-foreground hover:bg-primary/90 transition-colors duration-300 px-8 py-6 text-base font-medium shadow-md">
              <Link to="/CheaperInsurancePage">Se dina erbjudanden</Link>
            </Button>
          </div>

          {}
          <div ref={imgRef} className={`relative flex justify-center lg:justify-end transition-all duration-1000 delay-300 ease-out ${isImgVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="relative w-full max-w-md aspect-[3/4] rounded-sm overflow-hidden shadow-2xl shadow-shadow-color/10 border border-border/50">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/sunlight_forest_leaves.png" alt="Tesla Model 3 parkerad i modern miljö" className="w-full h-full object-cover transition-transform duration-1000 hover:scale-105" />
              {}
              <div className="absolute inset-0 bg-gradient-to-tr from-background/20 via-transparent to-background/10 mix-blend-overlay pointer-events-none"></div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}